export default __webpack_public_path__ + "static/media/github.fac8bfed.svg";